import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';

/* workaround for aot compiler issue in angular 4.3 */
export const SysAdmin = MojoWellKnownNames.RoleNames.MojoAdministrator;
export const SupplierAdmin = MojoWellKnownNames.RoleNames.SupplierAdministrator;
export const SupplierSeniorUser = MojoWellKnownNames.RoleNames.SupplierSeniorUser;
export const SupplierUser = MojoWellKnownNames.RoleNames.SupplierUser;

export const ClientAdmin = MojoWellKnownNames.RoleNames.ClientAdministrator;
export const ClientSeniorUser = MojoWellKnownNames.RoleNames.ClientSeniorUser;
export const Previewer = MojoWellKnownNames.RoleNames.Previewer;
export const FormsAdministrator = MojoWellKnownNames.PmaPermissions.FormsAdministrator;
export const User = MojoWellKnownNames.RoleNames.User;

export const TenantAdmin = MojoWellKnownNames.RoleNames.TenantAdministrator;
export const TenantSeniorUser = MojoWellKnownNames.RoleNames.TenantSeniorUser;
